import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Menu, MenuItem } from '@blueprintjs/core';
import { RootState } from 'data/root.reducers';
import { COMMON_GRID_ACTION } from './grid-enums';

const ActionMenu = ({
  context, data, disabled, isAdditionalWarrantStateEnabled,
}: any) => {
  const { t } = useTranslation();

  const {
    showActionMenuItem,
    hasPrivilegetoView,
    hasPrivilegeToCreateNew,
    hasPrivilegeToDownload,
    hasPrivilegeToDelete,
    hasPrivilegeToUpdateWarrantState,
  } = context.props;

  const showViewActionMenu = (
    (((showActionMenuItem
        && context.showActionMenuItem(COMMON_GRID_ACTION.View, data))
    ) || !showActionMenuItem) && hasPrivilegetoView
  );

  const showEditActionMenu = (
    (((showActionMenuItem
        && context.showActionMenuItem(COMMON_GRID_ACTION.Edit, data))
    ) || !showActionMenuItem) && hasPrivilegeToCreateNew
  );
  const showDownloadActionMenu = (
    (((showActionMenuItem
        && context.showActionMenuItem(COMMON_GRID_ACTION.Download, data))
    ) || !showActionMenuItem) && hasPrivilegeToDownload
  );
  const showDeleteActionMenu = (
    (((showActionMenuItem
        && context.showActionMenuItem(COMMON_GRID_ACTION.Delete, data))
    ) || !showActionMenuItem) && hasPrivilegeToDelete
  );

  const showRescheduleActionMenu = ((hasPrivilegeToUpdateWarrantState && showActionMenuItem &&
    showActionMenuItem(COMMON_GRID_ACTION.Reschedule, data))
      && isAdditionalWarrantStateEnabled);

  const showPauseActionMenu = ((hasPrivilegeToUpdateWarrantState && showActionMenuItem &&
    showActionMenuItem(COMMON_GRID_ACTION.Pause, data))
      && isAdditionalWarrantStateEnabled);
  const showResumeActionMenu = ((hasPrivilegeToUpdateWarrantState && showActionMenuItem &&
    showActionMenuItem(COMMON_GRID_ACTION.Resume, data))
      && isAdditionalWarrantStateEnabled);
  const showStartActionMenu = ((hasPrivilegeToUpdateWarrantState && showActionMenuItem &&
    showActionMenuItem(COMMON_GRID_ACTION.Start, data))
      && isAdditionalWarrantStateEnabled);
  const showStopActionMenu = ((hasPrivilegeToUpdateWarrantState && showActionMenuItem &&
    showActionMenuItem(COMMON_GRID_ACTION.Stop, data))
      && isAdditionalWarrantStateEnabled);

  return (
    <Menu>
      {
        // eslint-disable-next-line max-len
        showViewActionMenu
          ? (
            <MenuItem
              id={COMMON_GRID_ACTION.View}
              onClick={context.onActionMenuItemClick}
              disabled={disabled}
              text={t('common.grid.action.view')}
            />
          )
          : <div />
        }
      {
        showEditActionMenu
          ? (
            <MenuItem
              id={COMMON_GRID_ACTION.Edit}
              onClick={context.onActionMenuItemClick}
              disabled={disabled}
              text={t('common.grid.action.edit')}
            />
          )
          : <div />
      }
      {
        showDownloadActionMenu
          ? (
            <MenuItem
              id={COMMON_GRID_ACTION.Download}
              onClick={context.onActionMenuItemClick}
              disabled={disabled}
              text={t('common.grid.action.download')}
            />
          )
          : <div />
      }
      {
        showDeleteActionMenu
          ? (
            <MenuItem
              id={COMMON_GRID_ACTION.Delete}
              onClick={context.onActionMenuItemClick}
              disabled={disabled}
              text={t('common.grid.action.delete')}
            />
          )
          : <div />
      }
      {
        showRescheduleActionMenu
          ? (
            <MenuItem
              id={COMMON_GRID_ACTION.Reschedule}
              data-test="reschedule-action-menu-item"
              onClick={context.onActionMenuItemClick}
              disabled={disabled}
              text={t('common.grid.action.reschedule')}
            />
          )
          : <div />
      }
      {
        showPauseActionMenu
          ? (
            <MenuItem
              id={COMMON_GRID_ACTION.Pause}
              data-test="pause-action-menu-item"
              onClick={context.onActionMenuItemClick}
              disabled={disabled}
              text={t('common.grid.action.pause')}
            />
          )
          : <div />
        }
      {
        showResumeActionMenu
          ? (
            <MenuItem
              id={COMMON_GRID_ACTION.Resume}
              data-test="resume-action-menu-item"
              onClick={context.onActionMenuItemClick}
              disabled={disabled}
              text={t('common.grid.action.resume')}
            />
          )
          : <div />
        }
      {
        showStartActionMenu
          ? (
            <MenuItem
              id={COMMON_GRID_ACTION.Start}
              data-test="start-action-menu-item"
              onClick={context.onActionMenuItemClick}
              disabled={disabled}
              text={t('common.grid.action.start')}
            />
          )
          : <div />
      }
      {
        showStopActionMenu
          ? (
            <MenuItem
              id={COMMON_GRID_ACTION.Stop}
              data-test="stop-action-menu-item"
              onClick={context.onActionMenuItemClick}
              disabled={disabled}
              text={t('common.grid.action.stop')}
            />
          )
          : <div />
      }
    </Menu>
  );
};

const mapStateToProps = ({
  discoveryXcipio: {
    discoveryXcipioSettings: {
      isAdditionalWarrantStateEnabled,
    },
  },
}: RootState) => ({
  isAdditionalWarrantStateEnabled,
});

export default connect(mapStateToProps, null)(ActionMenu);
